import SectionHeader from "./SectionHeader";
import { testimonials } from "@/mocks/manhwa";

const values = [
  { icon: "ri-flashlight-line", title: "进度优先", desc: "把最新话与连载进度放在第一位，让追更读者第一时间掌握更新动态。" },
  { icon: "ri-verified-badge-line", title: "信息可信", desc: "所有连载状态与章节进度均经过人工复核，确保追更信息准确可信。" },
  { icon: "ri-group-line", title: "追更共创", desc: "与读者一起发现热门韩漫，根据真实热度持续优化推荐与排期。" },
];

export default function Testimonials() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeader
          tag="关于虚空韩漫网"
          title="专注韩漫追更的口碑之选"
          desc="虚空韩漫网是一群资深漫画读者共同维护的韩漫追更平台，我们相信：追更不该是一场满世界找更新的苦役，而应是一件轻松、有序又让人期待的事。"
        />

        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3 md:gap-5">
          {values.map((v) => (
            <div key={v.title} className="rounded-2xl border border-background-200/70 bg-background-50 p-6">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-xl bg-secondary-100 text-secondary-700">
                <i className={`${v.icon} text-2xl`}></i>
              </span>
              <h3 className="font-heading mt-4 text-base font-bold text-foreground-950 md:text-lg">{v.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3 md:gap-6">
          {testimonials.map((t) => (
            <figure key={t.name} className="flex flex-col rounded-2xl border border-background-200/70 bg-background-50 p-6">
              <div className="flex gap-1 text-accent-500">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-sm"></i>
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">{t.content}</blockquote>
              <figcaption className="mt-5 flex items-center gap-3">
                <img src={t.avatar} alt={`${t.name} 头像`} className="h-10 w-10 rounded-full object-cover" />
                <div>
                  <div className="text-sm font-semibold text-foreground-950">{t.name}</div>
                  <div className="text-xs text-foreground-500">{t.role}</div>
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}